// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Stack,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  ThemeProvider,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import MuiButton from 'components/__v5__/Button/MuiButton';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { normalText } from 'assets/colors/colors';
import { DeleteIcon } from 'assets/icons';
import previewTableTheme from './Theme/Theme';
import { CellData } from '../../../RenderFormField/TableFormField/types';
import TableCellPreview from './TableCellPreview/TableCellPreview';

const TableFormFieldPreview = ({
  field,
  error,
  isPreview,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
  prefilledElementIDs = [''],
}) => {
  const [, { updateAnswer, updatePreviewColumn, duplicateRow, deleteRow }] =
    useCustomForm();

  if (!field) return null;

  const checkIfRequired = useCallback(
    (colIndex) => field?.contents?.[0]?.[colIndex]?.isRequired,
    [field],
  );

  const handleAddRow = useCallback(() => {
    duplicateRow(field?.id, 0);
  }, [field]);

  return (
    <ThemeProvider theme={previewTableTheme}>
      <div className="form-table-container">
        <Typography
          variant="subtitle1"
          style={{ color: '#233759', fontWeight: 500, marginBottom: 3 }}
        >
          {field?.label ? field?.label : field?.name}
          {field?.isRequired ? <span style={{ color: 'red' }}> *</span> : null}
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {field?.type === 'table' && (
                  <th align="center" style={{ width: '50px' }}></th>
                )}
                {field?.headers?.map((header, ind) => (
                  <th key={`${header}-${ind}`}>
                    <Stack
                      direction="row"
                      spacing={1}
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        {header}
                        {checkIfRequired(ind) ? (
                          <span style={{ color: 'red' }}> *</span>
                        ) : null}
                      </Typography>
                    </Stack>
                  </th>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {field?.contents?.map((row: CellData[], rowIndex) => (
                <TableRow key={`${rowIndex}-${row[0]?.id}`}>
                  {field?.type === 'table' && (
                    <td
                      align="center"
                      style={{ width: '50px', minWidth: '50px' }}
                    >
                      {field?.contents?.length > 1 && (
                        <IconButton
                          onClick={() => deleteRow(field?.id, rowIndex)}
                          size="small"
                        >
                          <DeleteIcon
                            fontSize="small"
                            sx={{ color: normalText.light }}
                          />
                        </IconButton>
                      )}
                    </td>
                  )}
                  {row?.map((col, colIndex) => (
                    <td
                      key={col?.id}
                      {...(col?.width && {
                        style: {
                          minWidth: `${col?.width}px`,
                          maxWidth: `${col?.width}px`,
                        },
                      })}
                    >
                      <TableCellPreview
                        field={col}
                        error={error?.[col?.id]}
                        tableId={field?.id}
                        tableType={field?.type}
                        rowIndex={rowIndex}
                        colIndex={colIndex}
                        updateAnswer={updateAnswer}
                        updatePreviewColumn={updatePreviewColumn}
                        updateAnswerInPrefilledElements={
                          updateAnswerInPrefilledElements
                        }
                        shouldBeReadOnly={shouldBeReadOnly}
                        prefilledElementIDs={prefilledElementIDs}
                      />
                    </td>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {field?.type === 'table' && (
            <Box mt={2}>
              <Tooltip
                title={
                  isPreview ? 'Adding row is not available in preview' : ''
                }
                placement="top"
                disableHoverListener={!isPreview}
              >
                <span>
                  <MuiButton
                    variant="outlined"
                    color="secondary"
                    onClick={!isPreview && handleAddRow}
                    size="small"
                  >
                    Add Row
                  </MuiButton>
                </span>
              </Tooltip>
            </Box>
          )}
        </TableContainer>
      </div>
    </ThemeProvider>
  );
};

export default TableFormFieldPreview;
